import { GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getLocation } from "../../../../services/Location";
import { baseURL } from "../../../../config/api";
import { Menu, MenuItem, Stack } from "@mui/material";
import { CustomDataGrid } from "../../../../components/CustomDataGrid";

const filterItems = [
    {
        id: 0,
        label: "SKU/Item No",
    },
    {
        id: 1,
        label: "Model Name",
    }
]

export const WheelInventory = () => {
    const navigate = useNavigate();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);
    const [filterValue, setFilterValue] = useState(0);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [locationId, setLocationId] = useState<number>(0);
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const columns: GridColDef[] = [
        {
            field: "modelName",
            headerName: "Model Name",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Link to="/admin/settings/wheel-inventory/edit-wheel-inventory" state={params?.id} className="underline text-[#0000ff]">
                        {params?.value}
                    </Link>
                );
            },
        },
        {
            field: "brandName",
            headerName: "Brand Name",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "sku",
            headerName: "SKU/Item No",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "quantityOnHand",
            headerName: "Quantity On Hand",
            type: "number",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "reorderLevel",
            headerName: "Reorder Level",
            editable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: "rackCode",
            headerName: "Rack Code",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "shelf",
            headerName: "Shelf",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "locationName",
            headerName: "Loaction Name",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "inHouse",
            headerName: "Is House",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "waitingTimeUnit",
            headerName: "Waiting Time Unit",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "waitingTimeUnitValue",
            headerName: "Waiting Time Unit Value",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "salesTaxRate",
            headerName: "Sales Tax Rate",
            flex: 1,
            editable: false,
            sortable: false,
        },
    ];


    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    pageSize: paginationModel?.pageSize,
                };

                setPaginationModel(newPaginationModel);
            }, 1000);
        }

        return () => clearTimeout(timeOutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue !== "") {
            filterApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])


    const filterApiCall = (newPaginationModel: any) => {
        setLoading(true);
        let filterData: any[] = [];
        setLoading(true);
        if (locationId > 0) {
            switch (filterValue) {
                case 0:
                    fetch(`${baseURL}wheelInventories/GetWheelInventoriesReportByLocationIdItemNumerPagination?search=${searchValue}&locationId=${locationId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`)
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data?.wheelInventories?.map((item: any) => {
                                return {
                                    ...item,
                                    id: item?.inventoryId,
                                    inHouse: item?.inHouse ? "Yes" : "No"
                                };
                            })
                            setSearchTableData(filterData);
                            setTotalLength(data?.count);
                            setLoading(false);
                        })
                        .catch(error => {
                            setSearchTableData([]);
                            setTotalLength(0);
                            setLoading(false);
                            console.error(error);
                        });
                    break;
                case 1:
                    fetch(`${baseURL}wheelInventories/GetWheelInventoriesReportByLocationIdProductNamePagination?search=${searchValue}&locationId=${locationId}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`)
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data?.wheelInventories?.map((item: any) => {
                                return {
                                    ...item,
                                    id: item?.inventoryId,
                                    inHouse: item?.inHouse ? "Yes" : "No"
                                };
                            })
                            setSearchTableData(filterData);
                            setTotalLength(data?.count);
                            setLoading(false);
                        })
                        .catch(error => {
                            setSearchTableData([]);
                            setTotalLength(0);
                            setLoading(false);
                            console.error(error);
                        });
                    break;
            }
        }
        else {
            switch (filterValue) {
                case 0:
                    fetch(`${baseURL}wheelInventories/GetWheelInventoriesReportSearchWithItemNumber?search=${searchValue}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`)
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data?.wheelInventories?.map((item: any) => {
                                return {
                                    ...item,
                                    id: item?.inventoryId,
                                    inHouse: item?.inHouse ? "Yes" : "No"
                                };
                            })
                            setSearchTableData(filterData);
                            setTotalLength(data?.count);
                            setLoading(false);
                        })
                        .catch(error => {
                            setSearchTableData([]);
                            setTotalLength(0);
                            setLoading(false);
                            console.error(error);
                        });
                    break;
                case 1:
                    fetch(`${baseURL}wheelInventories/GetWheelInventoriesReportProductNamePagination?search=${searchValue}&page=${newPaginationModel?.page}&size=${newPaginationModel?.pageSize}`)
                        .then((res) => res.json())
                        .then((data) => {
                            filterData = data?.wheelInventories?.map((item: any) => {
                                return {
                                    ...item,
                                    id: item?.inventoryId,
                                    inHouse: item?.inHouse ? "Yes" : "No"
                                };
                            })
                            setSearchTableData(filterData);
                            setTotalLength(data?.count);
                            setLoading(false);
                        })
                        .catch(error => {
                            setSearchTableData([]);
                            setTotalLength(0);
                            setLoading(false);
                            console.error(error);
                        });
                    break;
            }
        }

    }



    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                pageSize: paginationModel?.pageSize,
            };

            setPaginationModel(newPaginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue === "") {
            setIsFirstTime(false)
            emptySearchApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel, locationId])


    const emptySearchApiCall = (newPaginationModel: any) => {
        if (locationId > 0) {
            setLoading(true);
            fetch(`${baseURL}wheelInventories/GetWheelInventoriesReportByLocationIdPagination/${locationId},${newPaginationModel?.page},${newPaginationModel?.pageSize}`)
                .then((res) => res.json())
                .then((data) => {
                    const result = data?.wheelInventories?.map((item: any) => {
                        return {
                            ...item,
                            id: item?.inventoryId,
                            inHouse: item?.inHouse ? "Yes" : "No"
                        };
                    })

                    setSearchTableData(result);
                    setTotalLength(data?.count);
                    setLoading(false);
                })
                .catch(error => {
                    setSearchTableData([]);
                    setTotalLength(0);
                    setLoading(false);
                    console.error(error);
                });
        }
        else {
            setLoading(true);
            fetch(`${baseURL}wheelInventories/GetWheelInventoriesReportPaging/${newPaginationModel?.page},${newPaginationModel?.pageSize}`)
                .then((res) => res.json())
                .then((data) => {
                    const result = data?.wheelInventories?.map((item: any) => {
                        return {
                            ...item,
                            id: item?.inventoryId,
                            inHouse: item?.inHouse ? "Yes" : "No"
                        };
                    })

                    setSearchTableData(result);
                    setTotalLength(data?.count);
                    setLoading(false);
                })
                .catch(error => {
                    setSearchTableData([]);
                    setTotalLength(0);
                    setLoading(false);
                    console.error(error);
                });
        }

    }



    return (
        <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
            <div className="w-full h-full bg-white p-4 rounded-md">
                <div className="flex items-center justify-end py-2">
                    <div className="flex items-center gap-1.5">
                        <div>
                            <select
                                value={locationId}
                                onChange={(e) => setLocationId(Number(e.target.value))}
                                className="w-[200px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                            >
                                <option value={0}>
                                    All
                                </option>
                                {locationOptions.map((loc: any, index: number) => (
                                    <option key={index} value={loc?.value}>
                                        {loc?.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <button className={`px-[8px] py-[6px] bg-primary rounded-lg border text-white flex items-center gap-1.5`}
                                onClick={() => navigate("/admin/settings/wheel-inventory/add-wheel-inventory")}
                            >
                                <span className="material-symbols-outlined text-[25px] font-light">
                                    add
                                </span>
                                <span className="text-xs font-medium">Wheel Inventory</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className={`w-full border border-[#E4E7EC] rounded-[16px]`}>
                    <div className={`flex justify-between items-center p-4 border-b border-[#E4E7EC]`}>
                        <div className="flex items-center gap-1.5">

                            <h2 className={`text-lg font-semibold text-[#1D2939]`}>Wheel Inventory</h2>
                        </div>
                        <div className="flex items-center gap-1.5">
                            <div >
                                <button
                                    className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid`}
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems={"center"}
                                        justifyContent={"center"}
                                    >
                                        <span className={` text-[14px] font-medium text-black-rgba`}>{selectedFilter}</span>
                                        {open ? <span className={`material-symbols-outlined  text-[25px] font-extralight`}>
                                            keyboard_arrow_up
                                        </span> : <span className={`material-symbols-outlined  text-[25px] font-extralight`}>
                                            keyboard_arrow_down
                                        </span>}
                                    </Stack>
                                </button>

                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                width: 170,
                                            }
                                        }
                                    }}
                                >
                                    {
                                        filterItems?.map((filter, index) => (
                                            <>
                                                <MenuItem
                                                    key={index}
                                                    sx={{ fontSize: "12px", marginBlock: "0px" }}
                                                    onClick={() => {
                                                        setSelectedFilter(filter.label)
                                                        setFilterValue(filter.id)
                                                        setAnchorEl(null);

                                                    }}>
                                                    <span className={`text-[16px] font-medium text-black-rgba`}>{filter.label}</span>
                                                </MenuItem>

                                            </>

                                        ))
                                    }
                                </Menu>
                            </div>
                            <div className={`flex px-[5px] py-[6px] items-center gap-2.5 rounded-lg border shadow-sm`}>
                                <span className={`material-symbols-outlined text-[25px] font-light text-black-rgba`}>
                                    search
                                </span>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    className={`border-none outline-none w-full bg-transparent`}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <CustomDataGrid
                        filteredRows={searchTableData}
                        columns={columns?.map(col => ({
                            ...col,
                            headerClassName: "bg-[#F9FAFB]",
                        }))}
                        loading={loading}
                        totalLength={totalLength}
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                    />
                </div>
            </div>

        </div>
    )
}